module.exports = __webpack_public_path__ + "static/media/login.209d8b5a.png";